var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLuckyWheelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "64 66 108 108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 120,
    r: 46,
    fill: "#FFC531"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118,120 L158,120 A40,40 0 0,1 146.28,148.28 Z",
    fill: "#FFCE3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118,120 L146.28,148.28 A40,40 0 0,1 118,160 Z",
    fill: "#FF5A45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118,120 L118,160 A40,40 0 0,1 89.72,148.28 Z",
    fill: "#33C86B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118,120 L89.72,148.28 A40,40 0 0,1 78,120 Z",
    fill: "#2E9BFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118,120 L78,120 A40,40 0 0,1 89.72,91.72 Z",
    fill: "#FFCE3A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118,120 L89.72,91.72 A40,40 0 0,1 118,80 Z",
    fill: "#FF5A45"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M118,120 L118,80 A40,40 0 0,1 146.28,91.72 Z",
    fill: "#33C86B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118,120 L146.28,91.72 A40,40 0 0,1 158,120 Z",
    fill: "#2E9BFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 120,
    r: 2.4,
    fill: "#FFFFFF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.41,
    cy: 150.41,
    r: 2.4,
    fill: "#FFFFFF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 163,
    r: 2.4,
    fill: "#FFFFFF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.59,
    cy: 150.41,
    r: 2.4,
    fill: "#FFFFFF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 120,
    r: 2.4,
    fill: "#FFFFFF"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.59,
    cy: 89.59,
    r: 2.4,
    fill: "#FFFFFF"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 77,
    r: 2.4,
    fill: "#FFFFFF"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.41,
    cy: 89.59,
    r: 2.4,
    fill: "#FFFFFF"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 120,
    r: 8,
    fill: "#FFFFFF",
    stroke: "#2A3B5E",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108,72 L128,72 L118,88 Z",
    fill: "#2A3B5E"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M160,78 L161.587,81.816 L165.707,82.146 L162.568,84.834 L163.527,88.854 L160,86.7 L156.473,88.854 L157.432,84.834 L154.293,82.146 L158.413,81.816 Z",
    fill: "#FFD23F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuckyWheelIcon);
export default __webpack_public_path__ + "static/media/lucky-wheel-icon.3f2454e3790329f14d01a04e38f67a62.svg";
export { ForwardRef as ReactComponent };